import { DragDropModule } from '@angular/cdk/drag-drop';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AddRecipientComponent } from 'add-recipient-lib';
import { AlertBannerComponent } from 'alert-banner-lib';
import { GoogleAnalyticsService } from 'analytics-lib';
import { AuthInterceptor } from 'auth-service-lib';
import { AutoCompleteComponent } from 'auto-complete-lib';
import { CompactFileListViewComponent } from 'compact-file-list-view-lib';
import { BullhornRetryInterceptor } from 'datasource-service-lib';
import { SalesforceEntityIconComponent } from 'entity-icon-lib';
import { EntityPickerComponent } from 'entity-picker-lib';
import { ENVIRONMENT, RUNTIME_ENVIRONMENT } from 'environments-lib';
import { FileTypeIconComponent } from 'filetype-icon-lib';
import { HeaderComponent } from 'header-lib';
import { InlineEditorComponent } from 'inline-editor-lib';
import { AutoGenIconPipe, GetInitialsPipe, TitleCasePipe } from 'pipes-lib';
import { TransformBytesToMB } from 'pipes-lib';
import { RippleDirective } from 'ripple-lib';
import { environment, runtimeEnvironment } from '../environments/environment';
import { EntityPreviewComponent } from './app-entity-preview/entity-preview.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfirmationDialogComponent } from './common-components/confirmation-dialog/confirmation-dialog.component';
import { DocumentSenderPickerComponent } from './common-components/document-sender-picker/document-sender-picker.component';
import { RecentActivityComponent } from './common-components/recent-activity/recent-activity.component';
import { SimpleTableComponent } from './common-components/simple-table/simple-table.component';
import { DocumentClientComponent } from './doc-client/document-client.component';
import { FileListViewComponent } from './file-list-view/file-list-view.component';
import { MergeBasketViewComponent } from './merge-basket-view/merge-basket-view.component';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { AdActionsDialogComponent } from './template-list-view/ad-actions-dialog/ad-actions-dialog.component';
import { EditConfigComponent } from './template-list-view/ad-actions-dialog/edit-config/edit-config.component';
import { PopupDialogComponent } from './template-list-view/ad-actions-dialog/edit-config/popup-dialog/popup-dialog.component';
import { EnvelopeButtonComponent } from './template-list-view/ad-actions-dialog/envelope-button/envelope-button.component';
import { AttachFileDialogComponent } from './template-list-view/selection-dialogs/attach-file-dialog/attach-file-dialog.component';
import { DatasourceAttachFileComponent } from './template-list-view/selection-dialogs/attach-file-dialog/datasource/datasource-attach-file.component';
import { LocalAttachFileComponent } from './template-list-view/selection-dialogs/attach-file-dialog/local/local-attach-file.component';
import { EntitySelectDialogComponent } from './template-list-view/selection-dialogs/entity-select-dialog/entity-select-dialog.component';
import { TemplateListViewComponent } from './template-list-view/template-list-view.component';
import { WorkflowInProgressComponent } from './workflow-in-progress/workflow-in-progress.component';

@NgModule({
  declarations: [
    AppComponent,
    DocumentClientComponent,
    ConfirmationDialogComponent,
    FileListViewComponent,
    MergeBasketViewComponent,
    SimpleTableComponent,
    SkeletonComponent,
    TemplateListViewComponent,
    GetInitialsPipe,
    TitleCasePipe,
    EntityPreviewComponent,
    WorkflowInProgressComponent,
    RecentActivityComponent,
    AdActionsDialogComponent,
    AttachFileDialogComponent,
    EntitySelectDialogComponent,
    EditConfigComponent,
    PopupDialogComponent,
    DatasourceAttachFileComponent,
    LocalAttachFileComponent,
    EnvelopeButtonComponent,
    DocumentSenderPickerComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    MatIconModule,
    DragDropModule,
    MatDialogModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatButtonToggleModule,
    MatTooltip,
    AlertBannerComponent,
    AutoCompleteComponent,
    InlineEditorComponent,
    EntityPickerComponent,
    AddRecipientComponent,
    HeaderComponent,
    TransformBytesToMB,
    AutoGenIconPipe,
    FileTypeIconComponent,
    CompactFileListViewComponent,
    RippleDirective,
    SalesforceEntityIconComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BullhornRetryInterceptor, multi: true },
    GoogleAnalyticsService,
    TransformBytesToMB,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: RUNTIME_ENVIRONMENT, useValue: runtimeEnvironment }
  ],
})
export class AppModule {}
